import React from 'react';
import {connect} from "react-redux";
import * as actionCreators from "../../actions/actionCreators"
import {getStreetViewPreview} from "../../api/google"
import EditAudit from "../../component/audit/editAudit.js";
import crypto from "crypto"

import {getBase64} from '../../utils/tools';

class EditAuditcon extends React.Component{
  constructor(props) {
    super(props);

    this.handleFileChange = this.handleFileChange.bind(this);
    this.handleFileRemove = this.handleFileRemove.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);

    this.state = {
        formData: {
            date: "",
            address: "",
            latitude: "",
            longitude:"",
            dateLimit: "",
            qualifications: [],
            mentions: [],
            reference: "",
            lot: "",
            client: "",
            report: {
                id: ""
            },
            company: {
              name: "",
              reference: "",
              manager: "",
              phone: "",
              email: "",
              siret: "",
              department: ""
            },
            summary: {},
            preview: {},
            status: "",
            notes: [],
            type: ""
        },
        submitted: false,
        openDialog: false,
        dataLoaded: false,
        emailsValue: 0,
        tabValue: 0
    };

  }

  componentWillReceiveProps(nextProps) {
    /* Si le paramètre de l'url a changé alors on charge le nouvel audit */
    if (nextProps.match.params.id !== this.props.match.params.id) {
      /* import l'audit */
      this.props.getAuditByIdAction(nextProps.match.params.id, this.props.audits)
      .then(res => {
        this.mergeStateAndFormdata()
      })
    }
  }

  componentWillMount() {
      /* import les organisations */
      this.props.getAuditTypesAction()
      /* import les qualifications */
      this.props.getQualificationsAction()
      /* import les mentions */
      this.props.getMentionsAction()
      /* import l'audit */
      this.props.getAuditByIdAction(this.props.match.params.id, this.props.audits)
      .then(res => {
        if (!this.state.dataLoaded)
          this.mergeStateAndFormdata()
      })

  }

  /* Merge les données de l'audit avec celle du formulaire afin de le pré-remplir */
  mergeStateAndFormdata() {
    let audit = [...this.props.audits, ...this.props.archives].find(a => a.id === parseInt(this.props.match.params.id, 10))
    let formData = Object.assign({}, this.state.formData);
    formData.date = (audit.date) ? audit.date : "";
    formData.dateLimit = (audit.date_limit) ? audit.date_limit : "";
    formData.address = (audit.address) ? audit.address : "";
    formData.longitude = (audit.longitude) ? audit.longitude : "";
    formData.latitude = (audit.latitude) ? audit.latitude : "";
    formData.reference = (audit.reference) ? audit.reference : "";
    formData.lot = (audit.lot) ? audit.lot : "";
    formData.client = (audit.client) ? audit.client : "";
    formData.type = (audit.type) ? audit.type.id : "";
    formData.status = (audit.status) ? audit.status : "";
    formData.notes = (audit.notes) ? audit.notes : [];
    formData.summary = (audit.summary) ? {path: audit.summary.path, title: audit.summary.title} : {};
    formData.preview = (audit.preview) ? {path: audit.preview.path, title: audit.preview.title} : {};
    formData.report.id = (audit.report.id) ? audit.report.id : "";
    formData.company.name = (audit.company.name) ? audit.company.name : "";
    formData.company.reference = (audit.company.reference) ? audit.company.reference : "";
    formData.company.manager = (audit.company.manager) ? audit.company.manager : "";
    formData.company.phone = (audit.company.phone) ? audit.company.phone : "";
    formData.company.email = (audit.company.email) ? audit.company.email : "";
    formData.company.siret = (audit.company.siret) ? audit.company.siret : "";
    formData.company.department = (audit.company.department) ? audit.company.department : "";

    let qualifications_id = audit.qualifications.map((qualif) => {
      return qualif.id
    })
    formData.qualifications = qualifications_id;

    let mentions_id = audit.mentions.map((mention) => {
      return mention.id
    })
    formData.mentions = mentions_id;
    this.setState({formData: formData, dataLoaded:true, submitted: false});


  }

  handleTabChange = (event, tabValue) => {
    this.setState({ tabValue });
  };

    handleClickOpenDialog = () => {
        this.setState({
            openDialog: true,
        });
    };

    handleClickCloseDialog = () => {
        this.setState({
            openDialog: false,
        });
    };

    handleChangeEmails = (event, emailsValue) => {
        this.setState({ emailsValue });
    };

    handleChangeEmailsIndex = index => {
        this.setState({ emailsValue: index });
    };

    handleTabChangeIndex = index => {
        this.setState({ tabValue: index });
    };

    handleDateChange = id => date => {
        const { formData } = this.state;
        formData[id] = date ? date.format("YYYY/MM/DD HH:mm:ss") : "";
        this.setState({ formData });
    };

  handleFileChange(event) {
    const target = event.target;
    if(target.files[0].type === "application/pdf" || target.files[0].type === "image/jpg" || target.files[0].type === "image/jpeg" || target.files[0].type=== "image/png") {
      getBase64(target.files[0]).then(res => {
        let formData = Object.assign({}, this.state.formData);
        formData[target.name] = {path: res, title: target.files[0].name};
        this.setState({formData: formData});
      });
    } else {
      this.props.displaySnackbar("error", "Format non pris en charge");
    }
  }

  handleFileRemove(id) {
    let formData = Object.assign({}, this.state.formData);
    formData[id] = {};
    this.props.closeConfirmation();
    this.setState({formData: formData});
  }

  handleInputChange(event, parent) {
    const { formData } = this.state;
    if(parent && typeof(parent) === "string") {
        if(event.target.name === "reference_company"){
            formData[parent]["reference"] = event.target.value;
        }else{
            formData[parent][event.target.name] = event.target.value;
        }
    }else if(event.target.name === "type"){
        formData[event.target.name] = event.target.value;
        formData["qualifications"] = [];
        formData["mentions"] = [];
    }else {
      formData[event.target.name] = event.target.value;
    }

    /* Si le champs longitude ou latitude est modifié alors on change la preview */
    if((event.target.name === "longitude" || event.target.name === "latitude")) {
      if (this.state.formData.longitude && this.state.formData.latitude) {
        getStreetViewPreview(this.state.formData.longitude, this.state.formData.latitude).then(res=>{
          let formData = Object.assign({}, this.state.formData);
          formData.preview = {path: res, title: "preview_"+crypto.randomBytes(10).toString('hex')};
          this.setState({formData: formData});
        })
      }
    }

    this.setState({ formData });
  }

  handleFormSubmit(e){
      var _this = this;
    e.preventDefault();
    this.setState({ submitted: true }, () => {
        let formData = Object.assign({}, this.state.formData);
        delete formData.report;
      this.props.updateAuditAction(this.props.match.params.id, formData).then(res => {
          /* Charge les events de l'agenda google */
          _this.props.getAuditsCalendarEventsAction().then(res => {
              //console.log(res);
              _this.setState({
                  submitted: false
              })
          }).catch(err=> {
              //console.log(err);
              _this.setState({
                  submitted: false
              })
          })
      }).catch(err => {
        this.setState({
          submitted: false
        })
      })
    })
  }

  render(){
      let audit = [...this.props.audits, ...this.props.archives].find(audit => audit.id === parseInt(this.props.match.params.id, 10));
      let nextAudit;
      let prevAudit;
      if(audit && audit.date){
            var audits_list = [...this.props.audits, ...this.props.archives].filter(x => x.date).sort((a, b) => {
                    var dateA = new Date(a.date), dateB = new Date(b.date);
                    return dateB - dateA;
              });
            var audit_index = audits_list.findIndex((el, index, array) => {
                  return (el.id === audit.id);
              });
          nextAudit = audits_list[audit_index - 1];
          prevAudit = audits_list[audit_index + 1];
      }
    return <EditAudit
      formData={this.state.formData}
      submitted={this.state.submitted}
      emailsValue={this.state.emailsValue}
      handleChangeEmails={this.handleChangeEmails}
      handleChangeEmailsIndex={this.handleChangeEmailsIndex}
      openDialog={this.state.openDialog}
      handleClickOpenDialog={this.handleClickOpenDialog}
      handleClickCloseDialog={this.handleClickCloseDialog}
      handleFormSubmit={this.handleFormSubmit}
      handleInputChange={this.handleInputChange}
      handleDateChange={this.handleDateChange}
      handleSelectChange={this.handleSelectChange}
      handleFileChange={this.handleFileChange}
      user={this.props.user}
      audit={audit ? audit : {}}
      nextAudit={nextAudit}
      prevAudit={prevAudit}
      listOfAuditTypes={this.props.listOfAuditTypes}
      listOfQualifications={this.props.listOfQualifications}
      listOfMentions={this.props.listOfMentions}
      displayConfirmation={this.props.displayConfirmation}
      handleFileRemove={this.handleFileRemove}
      handleTabChange={this.handleTabChange}
      handleTabChangeIndex={this.handleTabChangeIndex}
      tabValue={this.state.tabValue}
    ></EditAudit>
  }
}

const mapStateToProps=(state)=>{
    return state
};

export default connect (mapStateToProps, actionCreators)(EditAuditcon);



// WEBPACK FOOTER //
// ./src/container/audit/editAudit-container.js